<template>
  <div class="c-download-hang" :class="classes" :style="styles" v-if="!isApp" v-touch:panend="handleTouchEnd" v-touch:panmove="handleTouchMove">
    <span class="c-download-hang-icon" @click="open = !open">
      <svg-icon icon-class="arrow-left"></svg-icon>
    </span>
    <span class="c-download-hang-label moblink-app" @click="$emit('click')">{{ text }}</span>
    <div ref="bottom" class="c-download-hang-bottom" :class="bottomClass"></div>
    <div class="c-download-hang-safe-bottom" ref="safeBottom"></div>
  </div>
</template>
<script>
// import { onViewportResize } from '@/composables';

// import { onViewportResize } from '@/composables';

export default {
  props: {
    text: {
      type: String,
      default: 'APP内打开',
    },
    bottomClass: {
      type: [String, Array, Object],
      default: '',
    },
  },
  components: {},
  data() {
    return {
      startPageX: 0,
      startPageY: 0,
      X: 0,
      Y: 0,
      availWidth: document.documentElement.clientWidth,
      availHeight: document.documentElement.clientHeight,
      clientWidth: 0,
      clientHeight: 0,
      safeBottomHeight: 0,
      open: true,
      opacity: 0,
      isMoving: false,
    };
  },
  computed: {
    position() {
      const maxWidth = this.availWidth - this.clientWidth;
      const maxHeight = this.availHeight - this.clientHeight - this.safeBottomHeight;
      const X = this.startPageX + this.X;
      const Y = this.startPageY + this.Y;
      const left = X < 0 ? 0 : X > maxWidth ? maxWidth : X;
      const top = Y < 0 ? 0 : Y > maxHeight ? maxHeight : Y;
      return { left, top };
    },
    classes() {
      return { open: this.open };
    },
    styles() {
      // const left = this.position.left + 'px';
      const top = this.position.top + 'px';
      const transition = this.isMoving ? 'all 0.03s ease-in-out' : 'all 0.3s ease-in-out';
      return { top, opacity: this.opacity, transition };
    },
  },
  methods: {
    resize() {},
    handleTouchEnd() {
      this.startPageX = this.startPageX + this.X;
      this.startPageY = this.startPageY + this.Y;
      this.X = 0;
      this.Y = 0;
      console.log('handleTouchEnd');
      this.isMoving = false;
    },
    handleTouchMove(e) {
      console.log(e);
      this.isMoving = true;
      this.X = e.X;
      this.Y = e.Y;
    },
    handleChange() {
      this.availWidth = document.documentElement.clientWidth || window.innerWidth;
      this.availHeight = document.documentElement.clientHeight || window.innerHeight;
      const bottom = this.$refs.bottom ? this.$refs.bottom.clientHeight : 0;
      this.safeBottomHeight = this.$refs.safeBottom && this.$refs.safeBottom.offsetHeight;
      this.clientWidth = this.$el.clientWidth;
      this.clientHeight = this.$el.clientHeight;
      this.startPageX = this.availWidth / 2 - this.clientWidth / 2;
      this.startPageY = this.availHeight - this.clientHeight - this.safeBottomHeight - bottom;
    },
  },
  created() {},
  mounted() {
    setTimeout(() => {
      this.opacity = 1;
    }, 500);
    setTimeout(() => {
      this.handleChange();
    }, 100);
    // onViewportResize(() => {
    //   this.availWidth = document.documentElement.clientWidth;
    //   this.availHeight = document.documentElement.clientHeight;
    //   const bottom = this.$refs.bottom ? this.$refs.bottom.clientHeight : 0;
    //   this.safeBottomHeight = this.$refs.safeBottom && this.$refs.safeBottom.offsetHeight;
    //   this.clientWidth = this.$el.clientWidth;
    //   this.clientHeight = this.$el.clientHeight;
    //   this.startPageX = this.availWidth / 2 - this.clientWidth / 2;
    //   this.startPageY = this.availHeight - this.clientHeight - this.safeBottomHeight - bottom;
    // });
  },
  beforeUnmount() {},
  watch: {
    bottomClass: {
      immediate: true,
      handler() {
        this.$nextTick(() => {
          this.handleChange();
        });
      },
    },
  },
};
</script>
<style lang="scss">
.c-download-hang {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  position: fixed;
  opacity: 0;
  z-index: 999;
  right: 0px;
  top: calc(var(--root-height) - constant(safe-area-inset-bottom) - calc(var(--viewport-ratio) * 54px));
  top: calc(var(--root-height) - env(safe-area-inset-bottom) - calc(var(--viewport-ratio) * 54px));
  overflow: hidden;
  // padding-left: calc(var(--viewport-ratio) * 18px);
  width: calc(var(--viewport-ratio) * 38px);
  height: calc(var(--viewport-ratio) * 32px);
  box-sizing: border-box;
  background: #101010;
  box-shadow: 0px 0 calc(var(--viewport-ratio) * 8px) 0px rgba(0, 0, 0, 0.1);
  border-radius: calc(var(--viewport-ratio) * 20px) 0px 0px calc(var(--viewport-ratio) * 20px);
  transition: all 0.03s ease-in-out;
  &-icon {
    position: relative;
    margin-left: calc(var(--viewport-ratio) * 2px);
    width: calc(var(--viewport-ratio) * 12px);
    height: calc(var(--viewport-ratio) * 12px);
    font-size: calc(var(--viewport-ratio) * 12px);
    text-align: center;
    color: #ffffff;
  }
  &-label {
    flex: 1;
    opacity: 0;
    min-width: 0;
    overflow: hidden;
    display: none;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    height: calc(var(--viewport-ratio) * 40px);
    padding-left: calc(var(--viewport-ratio) * 6px);
    white-space: nowrap;
    font-weight: 400;
    font-size: calc(var(--viewport-ratio) * 14px);
    color: #ffffff;
  }

  &-safe-bottom {
    position: absolute;
    z-index: -99999;
    width: 1px;
    opacity: 0;
    height: constant(safe-area-inset-bottom);
    height: env(safe-area-inset-bottom);
  }
  &-bottom {
    position: absolute;
    z-index: -10000;
    opacity: 0;
    width: 1px;
    height: calc(var(--viewport-ratio) * 64px);
  }
  &.open {
    width: calc(var(--viewport-ratio) * 114px);
    .c-download-hang {
      &-icon {
        margin-left: calc(var(--viewport-ratio) * 15px);
        transform: rotate(180deg);
        transition: all 0.3s ease-in-out;
      }
      &-label {
        display: flex;
        opacity: 1;
        transition: all 0.3s ease-in-out;
      }
    }
  }
}
</style>
